import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';

export const DEFAULT_NS = 'translation';

i18n.use(initReactI18next).init({
  resources: {
    en: { [DEFAULT_NS]: en },
  },
  defaultNS: DEFAULT_NS,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
